import { createFileRoute } from '@tanstack/react-router'
import { requireCompleteProfile } from '@/lib/auth-guard'
import TeacherZone from '@/pages/TeacherZone'

export const Route = createFileRoute('/teacher-zone')({
  ...requireCompleteProfile(),
  component: TeacherZone,
})
